"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VizPortalDQWDataCatalogProvider = exports.VizPortalSearchResultsDataCatalogProvider = exports.LineageBrowserDataCatalogProvider = exports.VizClientDataCatalogProvider = void 0;
const tslib_1 = require("tslib");
/* eslint-disable deprecation/deprecation */
const client_1 = require("@apollo/client");
const catalog_core_1 = require("@tableau/catalog-core");
const vizportalclient_common_components_1 = require("@tableau/vizportalclient-common-components");
const react_query_1 = require("@tanstack/react-query");
const react_1 = tslib_1.__importDefault(require("react"));
const ErrorCatcher_1 = require("./error/components/ErrorCatcher");
const NavTelemetryEventEmitter_1 = require("./NavTelemetryEventEmitter");
const TelemetryContext_1 = require("./telemetry/TelemetryContext");
const TelemetrySender_1 = require("./telemetry/TelemetrySender");
/**
 * Provider for the EmbeddableVizClientLineagePanel since it doesn't need the [[ApiRequests]] object
 */
function VizClientDataCatalogProvider(_a) {
    var _b;
    var { telemetryVizClientApiCallback } = _a, props = tslib_1.__rest(_a, ["telemetryVizClientApiCallback"]);
    react_1.default.useEffect(() => {
        if (telemetryVizClientApiCallback) {
            TelemetrySender_1.telemetrySender.setTelemetryVizClientApiCallback(telemetryVizClientApiCallback);
        }
        return () => {
            if (telemetryVizClientApiCallback) {
                TelemetrySender_1.telemetrySender.resetTelemetryContractApiCallback();
            }
        };
    }, [telemetryVizClientApiCallback]);
    const restParams = { siteLuid: props.siteLuid, baseUrl: window.location.origin };
    return (react_1.default.createElement(ErrorCatcher_1.ErrorCatcher, null,
        react_1.default.createElement(client_1.ApolloProvider, { client: props.client },
            react_1.default.createElement(vizportalclient_common_components_1.RestApiServiceProvider, { params: Object.assign({}, restParams) },
                react_1.default.createElement(react_query_1.QueryClientProvider, { client: (0, catalog_core_1.queryClientGenerator)() },
                    react_1.default.createElement(catalog_core_1.SiteUrlsProvider, { value: props.siteUrls },
                        react_1.default.createElement(TelemetryContext_1.ReactTelemetryContext.Provider, { value: (_b = props.telemetryContext) !== null && _b !== void 0 ? _b : {} },
                            react_1.default.createElement(catalog_core_1.FeatureFlagsContext.Provider, { value: props.featureFlags }, props.children))))))));
}
exports.VizClientDataCatalogProvider = VizClientDataCatalogProvider;
/**
 * Provider for lineage browser components
 */
class LineageBrowserDataCatalogProvider extends react_1.default.Component {
    render() {
        var _a;
        return (react_1.default.createElement(ErrorCatcher_1.ErrorCatcher, null,
            react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(NavTelemetryEventEmitter_1.NavTelemetryEventEmitter, { uiActions: this.props.uiActions }),
                react_1.default.createElement(client_1.ApolloProvider, { client: this.props.client },
                    react_1.default.createElement(vizportalclient_common_components_1.RestApiServiceProvider, { params: { siteLuid: this.props.siteLuid } },
                        react_1.default.createElement(react_query_1.QueryClientProvider, { client: (0, catalog_core_1.queryClientGenerator)() },
                            react_1.default.createElement(catalog_core_1.SiteUrlsProvider, { value: this.props.siteUrls },
                                react_1.default.createElement(catalog_core_1.FeatureFlagsContext.Provider, { value: this.props.featureFlags },
                                    react_1.default.createElement(catalog_core_1.ApiRequestsProvider, { value: this.props.apiRequests },
                                        react_1.default.createElement(catalog_core_1.UIActionsProvider, { value: this.props.uiActions },
                                            react_1.default.createElement(TelemetryContext_1.ReactTelemetryContext.Provider, { value: (_a = this.props.telemetryContext) !== null && _a !== void 0 ? _a : {} },
                                                react_1.default.createElement(catalog_core_1.UserAndSiteSettingsContext.Provider, { value: { areUsersVisible: this.props.areUsersVisible, isUserAdmin: this.props.isUserAdmin } }, this.props.children))))))))))));
    }
}
exports.LineageBrowserDataCatalogProvider = LineageBrowserDataCatalogProvider;
/**
 * Provider for the data catalog stuff in VizPortal's search results page.
 *
 * Note (abrandon 2020-03-23) This probably contains more providers than we actually need for search results, but I don't want to risk
 * removing some and accidentally breaking something. If we ever get to a point where it's difficult to pass in the required info,
 * it might be possible to remove the provider in question.
 */
class VizPortalSearchResultsDataCatalogProvider extends react_1.default.Component {
    render() {
        return (react_1.default.createElement(ErrorCatcher_1.ErrorCatcher, null,
            react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(client_1.ApolloProvider, { client: this.props.client },
                    react_1.default.createElement(vizportalclient_common_components_1.RestApiServiceProvider, { params: { siteLuid: this.props.siteLuid } },
                        react_1.default.createElement(react_query_1.QueryClientProvider, { client: (0, catalog_core_1.queryClientGenerator)() },
                            react_1.default.createElement(catalog_core_1.SiteUrlsProvider, { value: this.props.siteUrls },
                                react_1.default.createElement(catalog_core_1.FeatureFlagsContext.Provider, { value: this.props.featureFlags },
                                    react_1.default.createElement(catalog_core_1.ApiRequestsProvider, { value: this.props.apiRequests },
                                        react_1.default.createElement(catalog_core_1.UIActionsProvider, { value: this.props.uiActions },
                                            react_1.default.createElement(catalog_core_1.UserAndSiteSettingsContext.Provider, { value: { areUsersVisible: this.props.areUsersVisible } }, this.props.children)))))))))));
    }
}
exports.VizPortalSearchResultsDataCatalogProvider = VizPortalSearchResultsDataCatalogProvider;
/**
 * Provider for DQW components in VizPortal.
 */
class VizPortalDQWDataCatalogProvider extends react_1.default.Component {
    render() {
        return (react_1.default.createElement(ErrorCatcher_1.ErrorCatcher, null,
            react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(client_1.ApolloProvider, { client: this.props.client },
                    react_1.default.createElement(vizportalclient_common_components_1.RestApiServiceProvider, { params: { siteLuid: this.props.siteLuid } },
                        react_1.default.createElement(react_query_1.QueryClientProvider, { client: (0, catalog_core_1.queryClientGenerator)() },
                            react_1.default.createElement(catalog_core_1.SiteUrlsProvider, { value: this.props.siteUrls },
                                react_1.default.createElement(catalog_core_1.FeatureFlagsContext.Provider, { value: this.props.featureFlags },
                                    react_1.default.createElement(catalog_core_1.ApiRequestsProvider, { value: this.props.apiRequests },
                                        react_1.default.createElement(catalog_core_1.UIActionsProvider, { value: this.props.uiActions }, this.props.children))))))))));
    }
}
exports.VizPortalDQWDataCatalogProvider = VizPortalDQWDataCatalogProvider;
//# sourceMappingURL=DataCatalogProvider.js.map